import { TableCard } from 'app/components'
import { EmpresaHeading } from './components/header/EmpresaHeading'
import { EmpresaValoresListHeader } from './components/header/EmpresaValoresListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EmpresaValoresTable } from './table/EmpresaValoresTable'

const EmpresaValoresList = () => {
  return (
    <>
      <EmpresaHeading />
      <TableCard>
        <EmpresaValoresListHeader />
        <EmpresaValoresTable />
      </TableCard>
    </>
  )
}

export const EmpresaValoresListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <EmpresaValoresList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
